class CollectionProductsGrid extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.productsGrid = this.querySelector('#collection-products-grid__grid');
    this.nextUrl = this.productsGrid.dataset.nextUrl;
    this.loadMoreButton = this.querySelector('#collection-products-grid__load-more-button');

    this.handleClick = this.handleClick.bind(this);
    this.loadMoreButton.addEventListener('click', this.handleClick);
  }

  disconnectedCallback() {
    this.loadMoreButton.removeEventListener('click', this.handleClick);
  }

  async handleClick(event) {
    const button = event.currentTarget;
    try {
      const response = await fetch(this.nextUrl);
      if (!response.ok) {
        throw new Error(`Respnse Status: ${response.status}`);
      }

      const html = await response.text()

      // get the next URL
      const parser = new DOMParser();
      const nextPage = parser.parseFromString(html, "text/html");
      const newProductsGrid = nextPage.querySelector("#collection-products-grid__grid");
      const nextUrl = newProductsGrid.dataset.nextUrl;

      // update data-next-url of <collection-products-grid>
      this.nextUrl = nextUrl;

      // remove button
      if (!nextUrl) {
        button.remove();
      }

      // append product image scroller in next URL to the <collection-products-grid>
      const productImgScrollers = nextPage.querySelectorAll("product-img-scroller");
      productImgScrollers.forEach((scroller) => {
        this.productsGrid.append(scroller);
      })

    } catch (error) {
      console.log(error);
    }
  }
}

customElements.define('collection-products-grid', CollectionProductsGrid);
